import { css } from "styled-components";
import breakpoint from "../../utils/breakpoint";
import space from "../../utils/space";
import unit from "../../utils/unit";
var propertyMap = {
  margin: {
    top: "margin-top",
    right: "margin-right",
    bottom: "margin-bottom",
    left: "margin-left"
  },
  padding: {
    top: "padding-top",
    right: "padding-right",
    bottom: "padding-bottom",
    left: "padding-left"
  }
};
var pushCss = function pushCss(side, value, spaceType) {
  var propertyName = propertyMap[spaceType][side];
  return css(["", ":", ";"], propertyName, value);
};
var pushBasicStyles = function pushBasicStyles(side, pushValue, includeReset, spaceType) {
  return css(["", " ", " ", ""], pushCss(side, pushValue, spaceType), includeReset && (side === "top" || side === "left") && css(["&:first-child{", "}"], pushCss(side, 0, spaceType)), includeReset && (side === "right" || side === "bottom") && css(["&:last-child{", "}"], pushCss(side, 0, spaceType)));
};
var PushSideStyles = function PushSideStyles(side, pushSpace, hasNoReset, pushType, spaceType) {
  var pushFunction = pushType === "space" ? space : unit;
  if (pushSpace.small) {
    return css(["", ";", "{", ";}", "{", ";}"], pushBasicStyles(side, pushFunction(pushSpace.small), !hasNoReset, spaceType), breakpoint("medium"), pushBasicStyles(side, pushFunction(pushSpace.medium), false, spaceType), breakpoint("large"), pushBasicStyles(side, pushFunction(pushSpace.large), false, spaceType));
  }
  return css(["", ";"], pushBasicStyles(side, pushFunction(pushSpace), !hasNoReset, spaceType));
};
export default PushSideStyles;